import type { CustomContentProps } from 'notistack';
import { SnackbarContent, useSnackbar } from 'notistack';
import { forwardRef } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Snackbar, type SnackbarVariant } from '~/ui/core/snackbar/Snackbar';

const createVariantSnackbar = (variant: SnackbarVariant) => {
    const VariantSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(({ id, message }, ref) => {
        const { closeSnackbar } = useSnackbar();
        const translate = useTranslate();

        return (
            <SnackbarContent ref={ref}>
                <Snackbar
                    closeLabel={translate('common.close')}
                    message={message}
                    variant={variant}
                    onClose={() => closeSnackbar(id)}
                />
            </SnackbarContent>
        );
    });

    VariantSnackbar.displayName = `${variant}Snackbar`;

    return VariantSnackbar;
};

// Override the built-in notistack variants so error/info/warning render our themed Snackbar.
// Registered on the SnackbarProvider via the `Components` prop.
export const snackbarComponents = {
    error: createVariantSnackbar('error'),
    info: createVariantSnackbar('info'),
    success: createVariantSnackbar('success'),
    warning: createVariantSnackbar('warning'),
};
